<!-- =========================================================================================
    File Name: Table.vue
    Description: Table demo - Imports all table demos
    ----------------------------------------------------------------------------------------
    Item Name: Vuexy - Vuejs, HTML & Laravel Admin Dashboard Template
      Author: Pixinvent
    Author URL: http://www.themeforest.net/user/pixinvent
========================================================================================== -->


<template>
    <div id="order-klinik">
      <div class="vx-row">
        <div class="vx-col w-1/2 mt-2 flex">
          <vs-card style="padding: 10px">
            <div slot="header">
              <h3>
                Order Lab Klinik
              </h3>
            </div>
            <div class="vx-row">
              <div class="vx-col w-full mt-2 mb-2 flex">
                <vs-select
                  autocomplete
                  class="w-2/3"
                  name="patient"
                  placeholder="Cari Pasien (No MR/Nama/Tgl Lahir)"
                  v-model="patient"
                  @input-change="searchPatient"
                  ref="patient"
                  >
                  <vs-select-item :key="index" :value="item.value" :text="item.text" v-for="(item,index) in listPatient" />
                </vs-select>
                <vs-button class="w-1/3 ml-4" color="#2196f3" type="filled" href="#" @click="$router.push('/pasien/create')">Pasien Baru</vs-button>
              </div>
            </div>

            <vs-divider position="center">
             Data Pasien
            </vs-divider>

             <vs-row>
               <vs-col class="w-full flex">
                  <vs-input disabled name="patientName" label="Nama Lengkap Pasien" class="w-3/4" v-model="patientName" style="color: red"/>
                  <vs-input disabled name="patientMR" label="No MR" class="w-1/4 ml-4" v-model="patientMR" style="color: red"/>
               </vs-col>
             </vs-row>
             <vs-row class="mt-2">
               <vs-col class="w-1/3">
                  <vs-input disabled name="patientBirthdate" label="Tgl Lahir" class="w-full" v-model="patientBirthdate" style="color: red"/>
               </vs-col>
               <vs-col class="w-1/3">
                  <vs-input name="patientAge" disabled label="Umur" v-model="patientAge" class="w-3/4 ml-4" style="color: red"/>
               </vs-col>
               <vs-col class="w-1/3">
                  <vs-input name="patientSex" disabled label="Jenis Kelamin" v-model="patientSex" class="w-full" style="color: red"/>
               </vs-col>
             </vs-row>

             <vs-divider position="center">
              Detail Order
             </vs-divider>

             <vs-row class="mt-2">
               <vs-col class="w-full flex">
                 <vs-select
                    autocomplete
                    class="w-11/12 mr-2"
                    name="visitType"
                    placeholder="Pilih Tipe Kunjungan"
                    v-model="visitType"
                    label="Tipe Kunjungan"
                    >
                    <vs-select-item :key="index" :value="item.id" :text="item.name" v-for="(item,index) in listVisitType" />
                  </vs-select>
                  <span
                      class="text-danger text-sm ml-4"
                      v-show="visitType == '' && validate"
                      >Tipe Kunjungan harus diisi</span>
                   <vs-select
                     autocomplete
                     class="w-11/12"
                     name="priority"
                     placeholder="Pilih Prioritas"
                     v-model="priority"
                     label="Prioritas"
                     >
                     <vs-select-item :key="index" :value="item.id" :text="item.name" v-for="(item,index) in listPriority" />
                   </vs-select>
                </vs-col>
             </vs-row>
             <vs-row class="mt-2">
               <vs-col class="w-full flex">
                   <vs-select
						autocomplete
						class="w-full mr-2"
						name="insurer"
						placeholder="Pilih Penjamin"
						v-model="insurer"
						label="Penjamin"
						>
						<vs-select-item :key="index" :value="item.id" :text="item.name" v-for="(item,index) in listInsurer" />
					  </vs-select>
					<vs-select
						 autocomplete
						 class="w-full"
						 name="ward"
						 placeholder="Pilih Ruangan"
						 v-model="ward"
						 label="Ruangan"
						 >
						 <vs-select-item :key="index" :value="item.id" :text="item.name" v-for="(item,index) in listWard" />
                   </vs-select>
				   <span
                     class="text-danger text-sm"
                     v-show="ward == '' && validate"
                     >Ruangan harus diisi</span>
               </vs-col>
			   <vs-col class="w-full mt-2">
                  <vs-select
                     autocomplete
                     class="w-full"
                     name="physician"
                     placeholder="Pilih DPJP"
                     v-model="physician"
                     label="Dokter DPJP"
                     >
                     <vs-select-item :key="index" :value="item.id" :text="item.name" v-for="(item,index) in listPhysicians" />
                   </vs-select>
                   <span
                       class="text-danger text-sm"
                       v-show="physician == '' && validate"
                       >Dokter DPJP harus diisi</span>
                </vs-col>
             </vs-row>
             <!--vs-row class="mt-4">
                <vs-col class="w-1/2">
                  <vs-input name="atensiDescr" label="Atensi Note" class="w-11/12" v-model="atensiDescr"/>
                </vs-col>
                
             </vs-row-->
          </vs-card>
        </div>
        <div class="vx-col w-1/2 mt-2 flex">
         <vs-card style="padding: 10px">
           <div slot="header">&nbsp;</div>
           <div class="vx-row">
             <div class="vx-col w-full mt-2 mb-2 flex">
               <vs-select
                 autocomplete
                 class="w-full"
                 name="test"
                 v-model="test"
                 placeholder="Cari Test/Pemeriksaan (Paket)"
                 @input-change="searchTest"
                 ref="test"
                 >
                 <vs-select-item :key="index" :value="item.parameter" :text="item.parameterName" v-for="(item,index) in listTest" />
               </vs-select>
             </div>
           </div>
           <vs-divider position="center">
             Test / Pemeriksaan
           </vs-divider>
           <div class="vx-row">
             <div class="vx-col w-full mt-2 mb-2">
              <vs-table stripe :data="listTestPatient" noDataText="Tidak Ada Data" style="text-align:center; max-height:360px; overflow:auto">
                  <template slot="thead">
                      <vs-th>No</vs-th>
                      <vs-th>Test/Pemeriksaan</vs-th>
                      <vs-th>&nbsp;</vs-th>
                  </template>

                  <template slot-scope="{data}">
                      <vs-tr :key="indextr" v-for="(tr, indextr) in data">
                          <vs-td>
                              {{indextr+1}}
                          </vs-td>
                          <vs-td style="width:80%">
                              {{(data[indextr]?data[indextr].parameterName:'')}}
                          </vs-td>
                          <vs-td>
                              <vs-button radius style="cursor: pointer;" @click="openConfirm(indextr)" color="danger" icon="delete"></vs-button>
                          </vs-td>
                      </vs-tr>
                  </template>
              </vs-table>
             </div>
            </div>
         </vs-card>
        </div>
      </div>
      <div class="vx-col w-full" vs-justify="center">
        <vs-row vs-w="12" vs-type="flex" vs-justify="center">
          <vs-button
            class="mr-4 mb-4"
            color="danger"
            @click="clear"
            >
            Batal
          </vs-button>
          <vs-button
            class="mr-4 mb-4"
            icon-pack="feather"
            color="#6488e4"
            @click="onConfirm"
            >
            Simpan
          </vs-button>
        </vs-row>
  		</div>
    </div>
</template>

<script>
import Datepicker from 'vuejs-datepicker';
import patient from "@/api/patient";
import master from "@/api/master";
import test from "@/api/test";
import moment from 'moment';

export default {
  components: {
    Datepicker
  },
  data() {
    return {
      test: '',
      patient: '',
      patientName: '',
      patientMR: '',
      patientBirthdate: '',
      patientAge: '',
      visitType: '',
      priority: 1,
      ward: '',
      atensiDescr: '',
      insurer: '',
      physician: '',
      patientSex: '',
      listPatient: [],
      listPriority: [],
      listVisitType: [],
      listWard: [],
      listInsurer: [],
      listPhysicians: [],
      listTest: [],
      listTestPatient: [],
      model: {},
      modelt: {},
      inputIsVisible: false,
      idxSelected: null,
      validate: false,
      loading: false
    };
  },
  methods: {
    showInput() {
      // Show the input component
      this.inputIsVisible = true;

      // Focus the component, but we have to wait
      // so that it will be showing first.
      this.nextTick(() => {
        this.focusInput();
      });
    },
    focusInput() {
      this.$refs.patient.$el.focus();
    },
    openConfirm(id) {
        this.idxSelected = id
        this.$vs.dialog({
            type: 'confirm',
            color: 'warning',
            title: `Konfirmasi`,
            text: 'Anda yakin menghapus data ini ?',
            acceptText: 'Ya',
            cancelText: 'Tidak',
            accept: this.acceptAlert
        })
    },
    onConfirm() {
      if (this.visitType==='' || this.ward==='' || this.physician==='') {
        this.validate=false;
		this.$vs.notify({
          title:'Notifikasi',
          time:3000,
          text:'Data Tipe Kunjungan, Ruangan dan Dokter DPJP harus diisi.',
          color:'danger',
          position:'top-right'
        })
      }

      if(this.patient!=='' && this.listTestPatient.length>0) {
        this.$vs.dialog({
            type: 'confirm',
            color: 'warning',
            title: `Konfirmasi`,
            text: 'Simpan data, data order akan dikirim ke Daftar Antrian ?',
            acceptText: 'Ya',
            cancelText: 'Tidak',
            accept: this.saveData
        })
      } else {
        this.$vs.notify({
          title:'Notifikasi',
          time:3000,
          text:'Data pasien dan test/pemeriksaan harus diisi.',
          color:'danger',
          position:'top-right'
        })
      }
    },
    clear() {
      this.test= '';
      this.patient= '';
      this.patientName= '';
      this.patientMR= '';
      this.patientBirthdate= '';
      this.patientAge= '';
      this.visitType= '';
      this.priority= 1;
      this.ward= '';
      this.insurer= '';
      this.physician= '';
      this.patientSex= '';
      this.listTestPatient.splice(0);
    },
    acceptAlert() {
      this.listTestPatient.splice(this.idxSelected, 1);
    },
    saveData() {
      this.loading = true;
			let config = {
				headers: {
					"content-type": "application/json"
				}
			};

      this.model = {};
      this.model.insurer = { id : this.insurer };
      this.model.ward = { id : this.ward };
      this.model.patient = { id : this.patient };
      this.model.physician = { id : this.physician };
      this.model.priority = { id : this.priority };
      this.model.patientType = { id : this.visitType };
      this.model.wrap = { measures : this.listTestPatient };
      if (this.atensiDescr!=='') {
        this.model.visitNote = this.atensiDescr;
      }

			test.saveOrderClinic(this.model, config)
				.then(res => {
					if (res.data.status) {
            this.$vs.dialog({
                type: 'confirm',
                color: 'success',
                title: `Konfirmasi`,
                text: 'Data telah berhasil di simpan, dan dikirim ke Daftar Antrian',
                acceptText: 'Buat Order Baru',
                cancelText: 'Lihat Daftar Antrian',
                accept: this.clear,
                cancel: this.toQueue
            })
					} else {
						this.$vs.notify({
							title: "Terjadi Kesalahan",
							time: 3000,
							text: res.data.message,
							color: "danger",
							position: "top-right"
						});
					}
				})
				.catch(error => {
					if (error.response) {
						this.$vs.notify({
							title: "An Error Occured",
							time: 3000,
							text: error.response.data.message,
							color: "danger",
							position: "top-right"
						});
					}
				})
        .finally(() => (this.loading = false));;
		},
    toQueue() {
      this.$router.push("/antrian/klinik/list");
    },
    async searchPatient(event) {
      if (event.target.value.length > 2) {
			    this.model["keyword"] = event.target.value;
          const frms = await patient.listPatient(this.model);
          var tmpArr = [];
          for (var i = 0; i < frms.data.data.length; i++) {
            var tmp = {}, xdate = '', tmpAge = '';
            if (frms.data.data[i].dob) {
              xdate = new Date(frms.data.data[i].dob);

              var a = moment(xdate);
              var b = moment();

              var years = b.diff(a, 'year');
              a.add(years, 'years');

              var months = b.diff(a, 'months');

              if (Number(months) > 0) {
                tmpAge = years+ '.' + months;
              } else {
                tmpAge = years;
              }
            }

            tmp.value= frms.data.data[i].id;
            tmp.text= frms.data.data[i].patientNumber+'_'
              +frms.data.data[i].name+'_'
              +(xdate!==''?moment(xdate).format('DD-MMM-YYYY'):'')+'_'
              +(frms.data.data[i].gender.id==1?'L':'P')

            tmp.name= frms.data.data[i].name;
            tmp.nomr= frms.data.data[i].patientNumber;
            tmp.age= tmpAge + ' tahun';
            tmp.gender= (frms.data.data[i].gender.id==1?'Laki-laki':'Perempuan');
            tmp.bod= moment(xdate).format('DD-MMM-YYYY');

            tmpArr.push(tmp);
          }
          this.listPatient = tmpArr;
      }
    },
    async searchTest(event) {
      if (event.target.value.length > 2) {
			    this.modelt["keyword"] = event.target.value;
          const frms = await test.getAvailableTestClinic(this.modelt);
          this.listTest = frms.data.data;
      }
    },
    async getMasterData() {
      this.listPriority = JSON.parse(localStorage.getItem("listPriority"));
      this.listVisitType = JSON.parse(localStorage.getItem("listVisitType"));
      this.listInsurer= JSON.parse(localStorage.getItem("listInsurer"));
      this.listWard= JSON.parse(localStorage.getItem("listWard"));
      this.listPhysicians= JSON.parse(localStorage.getItem("listPhysicians"));
      this.listTest= JSON.parse(localStorage.getItem("listAvailableTestClinic"));
    }
  },
  computed: {
  },
  watch: {
    patient: function(val) {
      let obj = this.lodash.find(this.listPatient, o => {
        return o.value === val;
      });

      if (obj) {
        this.patientName = obj.name;
        this.patientMR = obj.nomr;
        this.patientAge = obj.age;
        this.patientSex = obj.gender;
        this.patientBirthdate = obj.bod;
      }
    },
    test: function(val) {
	console.log('val :'+val);
      let obj = this.lodash.find(this.listTest, o => {
        return o.parameter === val;
      });

      if (obj) {
        this.listTestPatient.push(obj);
      }
    }
  },
  mounted() {
    this.focusInput();
  },
  created() {
    this.getMasterData();
  }
};
</script>
